/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Domestic animal affected
 */
export type ImportReportDtoDomesticAnimalAffected =
  (typeof ImportReportDtoDomesticAnimalAffected)[keyof typeof ImportReportDtoDomesticAnimalAffected];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportReportDtoDomesticAnimalAffected = {
  yes: 'yes',
  no: 'no',
  dontKnow: 'dontKnow',
} as const;
